import { create } from 'zustand';
import { persist } from "zustand/middleware";
import { IUsuario } from "../types/Usuario.interface";

type State = {
  token: string  | '';
  usuario: IUsuario | null;
  isAuthenticated: boolean;
};

type Actions = {
  setToken: (token: string) => void;
  setUsuario: (usuario: IUsuario) => void;
  logout: () => void;
};

export const useAuthStore = create(
  persist<State & Actions>(
    (set) => ({
      token: '',
      usuario: null,
      isAuthenticated: false,
      setToken: (token: string) =>
        set((state) => ({
          token,
          isAuthenticated: !!token,
        })),
      setUsuario: (usuario: any) => set((state) => ({ usuario })),
      logout: () =>
        set((state) => ({ token: '', usuario: null, isAuthenticated: false })),
    }),
    {
      name: "auth",
    }
  )
);

